/**
 *  Planner app id which uniquely identifies the app in OCV
 */ export const PlannerAppOCVId = 2204;
/**
 * Feedback button id in Uno
 */ export const FeedbackButtonId = "FeedbackButtonIdInUno";
export var OcvFeatureAreas;
(function(OcvFeatureAreas) {
    // Copilot related features in basic plans
    OcvFeatureAreas["GsdInBasicPlansFeedback"] = "Copilot GSD in Basic Plans";
    // Status report in premium plans
    OcvFeatureAreas["StatusReportFeedback"] = "Status Report in Premium Plans";
    // Status report in Evo Plans
    OcvFeatureAreas["StatusReportInEvoPlansFeedback"] = "Status Report in Evo Plans";
    // Copilot related features in premium plans
    OcvFeatureAreas["GsdInPremiumPlansFeedback"] = "Copilot GSD in Premium Plans";
    // Copilot chat feature
    OcvFeatureAreas["CopilotChatFeedback"] = "Copilot Planner";
    // Planner agent in Planner
    OcvFeatureAreas["PMAInPlannerFeedback"] = "Planner agent in Planner";
})(OcvFeatureAreas || (OcvFeatureAreas = {}));
export var OcvFeatureNames;
(function(OcvFeatureNames) {
    // Generated tasks per goal in Goals page, each goal can have it's own AI disclaimer
    OcvFeatureNames["GoalsGridGenerateTasks"] = "Generate Tasks output in Goals page";
    // Generated tasks in Activity section of Home page
    // NOTE: This view is about to be deprecated
    OcvFeatureNames["ProjectHomeActivitySection"] = "Project Home Activity Section";
    // Generated tasks in Kickoff section of Home page
    // NOTE: This view is about to be deprecated
    OcvFeatureNames["ProjectHomeKickOffSection"] = "Project Home Kick Off Section";
    // Task execution output in Loop page inside Task Details Editor for basic as well as premium plans
    OcvFeatureNames["TaskExecutionOutputInTaskDetailsEditor"] = "Task Execution Output in Task Details Editor";
    // Generated status report output in Status report page
    OcvFeatureNames["GenerateStatusReportOutput"] = "Generate report output in Status report page";
    // Generated tasks output in Basic Plans
    OcvFeatureNames["GenerateTasksOutputInBasicPlans"] = "Generate Tasks output in Basic Plans";
})(OcvFeatureNames || (OcvFeatureNames = {}));
